import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProductContainer from "./containers/Product/ProductContainer";
import NoMatch from "./components/NoMatch/";
import "./App.css";
import HTML5Backend from "react-dnd-html5-backend";
import { default as TouchBackend } from "react-dnd-touch-backend";

import { DragDropContext } from "react-dnd";
// import MobileDialog from "./components/MobileDialog/MobileDialog";
import LandscapeWarning from "./components/LandscapeWarning/LandscapeWarning";
import Customize from "./pages/Customize";
import Review from "./pages/Review";

const isTouchDevice =
  "ontouchstart" in window ||
  (window.DocumentTouch && document instanceof window.DocumentTouch);
const dndBackend = isTouchDevice ? TouchBackend : HTML5Backend;

class App extends React.Component {
  render() {
    return (
      <Router basename="/customizer">
        <div className="app-container">
          <Routes>
            <Route path="/:id/" element={<ProductContainer />}>
              <Route path="customize/*" element={<Customize />} />
              <Route path="review/*" element={<Review />} />
            </Route>
            <Route element={<NoMatch />} />
          </Routes>
          {/* <MobileDialog /> */}
          <LandscapeWarning />
        </div>
      </Router>
    );
  }
}

export default DragDropContext(dndBackend)(App);
